import React, { useRef, useState } from "react";
import Popper from "@mui/material/Popper";
import Grow from "@mui/material/Grow";
import Paper from "@mui/material/Paper";
import ClickAwayListener from "@mui/material/ClickAwayListener";
import MenuList from "@mui/material/MenuList";
import MenuItem from "@mui/material/MenuItem";
import Divider from "@mui/material/Divider";
import Avatar from "@mui/material/Avatar";
import LogoutOutlinedIcon from "@mui/icons-material/LogoutOutlined";
import "./layout.css";
import Cookies from "js-cookie";
import CircleIcon from "@mui/icons-material/Circle";
import VpnKeyIcon from "@mui/icons-material/VpnKey";
import { useNavigate } from "react-router-dom";
import BasicModal from "../../pages/auth/login/loginModal";
import EditIcon from "@mui/icons-material/Edit";
import { useDispatch, useSelector } from "react-redux";
import { editProfileAPI } from "../../redux/action/UserAction";
import { userSelector } from "../../redux/slices/userSlice";

const PopperMenu = ({ menuOpen, setMenuOpen }) => {
  const anchorRef = useRef(null);
  const userdata = Cookies.get("userAccounts");
  const userDetails = userdata ? JSON.parse(userdata) : [];
  const currentUser = Cookies.get("currentUser");

  const { userProfileData } = useSelector(userSelector);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [open, setOpen] = useState(false); // modal open state

  // Handle logout logic and switch between stored user accounts
  const handleLogout = (path) => {
    if (currentUser) {
      const updatedUsers = userDetails.filter(
        (user) => user.username !== currentUser
      );

      if (updatedUsers.length > 0) {
        const newCurrentUser = updatedUsers[0];
        Cookies.set("userAccounts", JSON.stringify(updatedUsers), {
          expires: 370,
        });
        Cookies.set("currentUser", newCurrentUser.username, { expires: 370 });
        Cookies.set("accessToken", newCurrentUser.token, { expires: 370 });
        window.location.reload();
      } else {
        // Clear all session and cookie data on full logout
        Cookies.remove("userAccounts");
        Cookies.remove("currentUser");
        Cookies.remove("accessToken");
        sessionStorage.clear();
        window.location.reload();
      }
    }
  };

  // Handle profile image file input and convert to base64
  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        const base64String = reader.result;
        dispatch(editProfileAPI(base64String));
      };

      reader.readAsDataURL(file);
    }
  };

  return (
    <>
      {/* Hidden file input for profile image upload */}
      <input
        id="edit-profile"
        type="file"
        style={{ display: "none" }}
        accept=".png, .svg, .jpeg, .jpg"
        onChange={handleFileChange}
      />

      {/* Popper menu container */}
      <Popper
        open={menuOpen}
        anchorEl={anchorRef.current}
        role={undefined}
        placement="bottom-start"
        transition
        disablePortal
        className="popper-container"
      >
        {({ TransitionProps }) => (
          <Grow {...TransitionProps}>
            <Paper>
              <ClickAwayListener onClickAway={() => setMenuOpen(false)}>
                <MenuList autoFocusItem={menuOpen} id="composition-menu">
                  {/* List of user accounts */}
                  {userDetails?.map((e) => (
                    <>
                      <div className="menu-header">
                        <Avatar
                          src={userProfileData?.profile_pic}
                          alt="User"
                          className="avatar"
                          sx={{ width: 40, height: 40 }}
                        />
                        {currentUser === e?.username && (
                          <CircleIcon
                            sx={{
                              color: "green",
                              fontSize: "13px",
                              position: "absolute",
                              margin: "10px 0px 35px 25px",
                            }}
                          />
                        )}
                        <div className="user-info">
                          <p className="user-name">{e?.username}</p>
                          <p className="user-email">{e?.email}</p>
                        </div>
                      </div>
                      <Divider />
                    </>
                  ))}

                  {/* Menu options */}
                  <MenuItem
                    onClick={() => navigate("/changePassword")}
                    className="menu-item"
                  >
                    <VpnKeyIcon />
                    Change Password
                  </MenuItem>
                  <MenuItem className="menu-item">
                    <EditIcon />
                    <label htmlFor="edit-profile">Edit Profile</label>
                  </MenuItem>
                  <MenuItem onClick={handleLogout} className="menu-item">
                    <LogoutOutlinedIcon />
                    Log Out
                  </MenuItem>
                </MenuList>
              </ClickAwayListener>
            </Paper>
          </Grow>
        )}
      </Popper>

      {/* Optional login modal fallback */}
      <BasicModal open={open} setOpen={setOpen} />
    </>
  );
};

export default PopperMenu;
